// extracted by mini-css-extract-plugin
module.exports = {"card-container":"style_card-container__2Cxw9","content":"style_content__2acdx","actions":"style_actions__1aO3V","action":"style_action__2I19L"};